import { createShipIconNL } from "@components/map/mapComponents/shipIcon"
import type { LatLng } from "leaflet"
import { DataSetter } from "../utils/mapLayers"
import { getWorldCopyLongitudeOffsets, getWorldCopyPoints } from "./vesselTrackMapEdges"

export const addVesselsNotClickable: DataSetter = (
	dispatch,
	queryClient,
	layerGroup,
	layerData,
	navigate,
	map
) => {
	if (layerGroup === undefined) return

	const { vesselsNotClickableData } = layerData
	if (vesselsNotClickableData === undefined) return

	const { vessels } = vesselsNotClickableData
	if (vessels.length === 0) return

	layerGroup.clearLayers()
	const longitudeOffsets = getWorldCopyLongitudeOffsets(map?.getBounds())

	for (const ship of vessels) {
		if (
			ship?.position?.hasOwnProperty("lat") !== true ||
			ship?.position?.hasOwnProperty("lon") !== true
		) {
			continue
		}
		if (isNaN(ship.position.lat) === true || isNaN(ship.position.lon) == true) {
			continue
		}
		const shipCoords: LatLng[] = getWorldCopyPoints(
			{
				latitude: ship.position.lat,
				longitude: ship.position.lon,
			},
			longitudeOffsets
		).map((point) => L.latLng(point.latitude, point.longitude))

		for (const shipCoord of shipCoords) {
			layerGroup.addLayer(
				L.marker(shipCoord, {
					icon: createShipIconNL(
						ship.position.heading,
						ship.condition,
						false,
						ship.position.lat,
						undefined, //main_dimensions_vessel_data[ship.name]?.LOA,
						undefined, //main_dimensions_vessel_data[ship.name]?.Breadth,
						map?.getZoom()
					),
					pane: "vesselsPane",
				})
			)
		}
	}
}
